import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/_services/global.service';
import {  GroupService, ToolbarService } from '@syncfusion/ej2-angular-grids';
import { DetailRowService } from '@syncfusion/ej2-angular-grids';
import { SortService } from '@syncfusion/ej2-angular-grids';
import { ApiService } from 'src/app/_services/api.service';


@Component({
  selector: 'app-segnalazioni',
  templateUrl: './segnalazioni.component.html',
  styleUrls: ['./segnalazioni.component.css'],
  providers: [DetailRowService,SortService,ToolbarService,GroupService]
})
export class SegnalazioniComponent implements OnInit {
  segnalazioniAperte:any=[];
  totRecords:number=0;
  public toolbar: string[];
  constructor(
    private apiService: ApiService,
    public globalService : GlobalService,
    public router: Router,
  ) { }

  ngOnInit(): void {
    this.toolbar = ['Search'];

    let params= {id_user:this.globalService.loggedUser.id};
    this.apiService.get('users/logininfokpi',params).subscribe(data => {
      let params=data.Result[0];
      this.apiService.get('todo/segnalazioniaperte',params).subscribe(data => {
        this.segnalazioniAperte=data.Result;
        this.totRecords=this.segnalazioniAperte.length;
      });
    });
    
  }
  
  goto(){
    this.router.navigateByUrl('/java/sign/login/LogonServletSign?oper=1'.replace('?','QUESTION').replace('=','UGUAL'));    
  }

  apri(data){
    if(data.modulo=='segnalazioni'){
      let logInfo = JSON.parse(localStorage.getItem("logInfo"));
      let params={
        oper:6,
        id_sign:data.id,
        password:logInfo.password,
        userNamelogin:logInfo.username
      }
      this.globalService.submitForm('sign/login/LogonServletSign','POST',params);
   
    }
  }
}
